import styled from 'styled-components/macro'

export const TranNum = styled.span`
  padding-left: 0.1rem;
  color: #0097fe;
  font-weight: 600;
`

export const TableTit = styled.div`
  padding-top: 2rem;
  font-size: 14px;
  p {
    padding-bottom: 0.4rem;
  }
`
